<section id="bp" *ngIf="hodnotenie.type" class="p-3">

  <lib-dialog-header
    [titulok]="'Hodnotenie predmetu'"
    [predmetNazov]="hodnotenie.predmetNazov"
    [predmetSkratka]="hodnotenie.predmetSkratka"
    >
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography p-0">

    <div class="m-5" *ngIf="hodnotenie.hodnotenia == null || hodnotenie.hodnotenia.length == 0">
      <div i18n>Záznam o hodnotení predmetu sa nepodarilo získať.</div>
    </div>

    <div *ngFor="let h of hodnotenie.hodnotenia">
      <div class="text-center">
        <div>{{h.terminKod}} - {{h.terminPopis}}</div>
        <div><strong>{{h.hodnotenieKod}} - {{h.hodnoteniePopis}}</strong></div>
        <div>{{h.udelil}}</div>
        <div>{{h.udelilDatum | date}}</div>
      </div>
      <br/>
      <div>
        <div *ngIf="h.uznane">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Uznané</span>
          </mat-checkbox>
        </div>
        <div *ngIf="h.dovezene">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Dovezené</span>
          </mat-checkbox>
        </div>
        <div *ngIf="h.mozeSaPrihlasit">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Môže sa prihlásiť</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>

<section id="ss" *ngIf="hodnotenieSS.type">

    <h2 mat-dialog-title class="gray fw-bold d-none d-sm-block">{{hodnotenieSS.predmetSkratka}}</h2>
    <h2 mat-dialog-title class="d-none d-sm-block">{{hodnotenieSS.predmetNazov}}</h2>
    <div class="d-block d-sm-none">{{hodnotenieSS.predmetSkratka}} - {{hodnotenieSS.predmetNazov}}</div>

  <hr/>

  <mat-dialog-content class="mat-typography">

    <div class="m-5" *ngIf="hodnotenieSS.hodnotenia == null || hodnotenieSS.hodnotenia.length == 0">
      <div i18n>Záznam o hodnotení predmetu sa nepodarilo získať.</div>
    </div>

    <div *ngFor="let h of hodnotenieSS.hodnotenia">
      <div class="text-center">
        <div><i>{{h.terminKod}} - {{h.terminPopis}}</i></div>
        <div><b>{{h.kod}} - {{h.popis}}</b></div>
        <div>{{h.datum | date}}</div>
      </div>
      <div *ngIf="h.tema" class="mt-3">
        <div class="gray" i18n>Záverečná práca</div>
        {{h.tema}}
      </div>
      <div *ngIf="h.otazky && h.otazky.length > 0" class="mt-3">
        <div class="gray" i18n>Otázky</div>
        <ol>
          <li *ngFor="let o of h.otazky">{{o.text}}</li>
        </ol>
      </div>
      <div *ngIf="h.vyjadrenie" class="mt-3">
        <div class="gray" i18n>Vyjadrenie komisie</div>
        {{h.vyjadrenie}}
      </div>
      <hr/>
    </div>

  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>

<section id="xx" *ngIf="!hodnotenie.type && !hodnotenieSS.type" class="p-3">

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h2 mat-dialog-title class="text-black-50">Detail hodnotenia</h2>

  <hr/>

  <mat-dialog-content class="mat-typography p-0">

    <div class="m-5" i18n>Záznam o hodnotení predmetu sa nepodarilo získať.</div>

  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>

